import React, { Component } from 'react'
import {Link} from 'react-router-dom';
import FpgDisableIcon from './../../../icons/fpgdisableicon';
import FpgpublishIcon from './../../../icons/fpgpublishicon';
import FpgDeleteIcon from './../../../icons/fpgdeleteicon';
import FpgeeditIcon from '../../../icons/fpgediticon';
import Dropdown from '../../../component/Dropdown';
import CheckBox from '../../../component/CheckBox';
import Textarea from '../../../component/Textarea';
import { bindActionCreators } from 'redux';
import { ActCreators } from '../../../redux/bindActionCretor';
import service from '../../../services';
import { connect } from 'react-redux';
import { IoTThingsGraph } from 'aws-sdk';
import ErrorPopUp from '../../../component/errorPopUp';
import PopUpCustomAll from '../../../component/fpg/create/popUpCustomAll';
import Loader from '../../../component/loader';
import { PAF_TYPES } from '../../../cosntants';


const mapStateToProps = state => ({
    PostAcceptanceEditListId:state.PostAcceptanceEditListId
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};
let sub;

const SingleDropDown = (props) => {
    return(
        <div className="ps_prod_que">
                <div className="disp_flex">
                    <div className="ps_prod_que_label field_row">
                        <label>{props.label}</label>
                    </div>
                    <div className="ps_action field_row">
                        {/* <div className="d_flex d_flex_align_center">
                            <label>option</label>
                        </div> */}
                        { props.label==='Did you use any stock footage in your film?' ?
                        <>{<div className="d_flex d_flex_align_center">
                        <label>{props.useStockFootage}</label>
                        </div> }</> :
                        props.label==='What primary computer hardware did you use to complete your film?' ?
                        <>{<div className="d_flex d_flex_align_center">
                            <label>{props.useHardware}</label>
                        </div> }</> :
                        // props.label==='What other technology - hardware or software, did you use to produce your film? If not applicable, select None' ?
                        // <>{<div className="d_flex d_flex_align_center">
                        // <label>{props.useOtherTechnologyHardware}</label>
                        // </div> }</> :
                        // props.label==='Did you use 3D real-time tools/engines in the making of this experience?' ?
                        // <>{<div className="d_flex d_flex_align_center">
                        // <label>{props.realTimes3DTools}</label>
                        // </div> }</> :
                        // props.label==='Which creative funding platform did you use to produce your film?' ?
                        // <>{<div className="d_flex d_flex_align_center">
                        // <label>{props.fundingPlatform}</label>
                        // </div> }</> :
                        // props.label==='Are you open to sharing distribution data on your Project?' ?
                        // <>{<div className="d_flex d_flex_align_center">
                        // <label>{props.sharingDistribution}</label>
                        // </div> }</> :
                        // props.label==='Do you have interest in hybrid distribution?' ?
                        // <>{<div className="d_flex d_flex_align_center">
                        // <label>{props.hybridDistribution}</label>
                        // </div> }</> :
                        props.label==='Did you use Dropbox (or Dropbox Replay, Sign, or DocSend) during the planning, production, or distribution of your film/project?' ?
                        <>{<div className="d_flex d_flex_align_center">
                        <label>{props.useDropbox}</label>
                        </div> }</> :
                        props.label==='Did you use Adobe Creative Cloud software for any of the pre-production, production, post-production or marketing of your film?' ?
                        <>{<div className="d_flex d_flex_align_center">
                        <label>{props.useAdobeProducts}</label>
                        </div> }</> :
                        ''}
                    </div>
                </div>
            </div>
    )
}

const ProductQuestion = (props) => {
    {console.log('props.cameras:::',props)}
    return(
       
            <div className="ps_prod_que">
                <div className="disp_flex">
                    <div className="ps_prod_que_label field_row">
                        <label>{props.label}</label>
                        {props.label2 && <label>{props.label2}</label>}
                    </div>
                    {/* <div className="ps_action field_row">
                        <div className="d_flex d_flex_align_center">
                            <div className="field_row_inner">
                                <label>BRAND</label>
                                <label>BRAND VALUE</label>
                            </div>
                            <div className="field_row_inner">
                                <label>MODEL</label>
                                <label>MODEL VALUE</label>
                            </div>
                            <div className="field_row_inner">
                                <label>OTHER MODEL NAME </label>
                                <label>OTHER MODEL VALUE</label>
                            </div>
                        </div>
                    </div> */}
                    <div className="ps_action field_row">
                        <div className="d_flex d_flex_align_center">
                            {
                                props.label==='What camera did you use to shoot your project(make/model)?' ?
                                 <>
                                { props.cameras && props.cameras?.length >0 && props.cameras?.map((item)=>{
                                return(
                                    <div className="d_flex d_flex_align_center">
                                        <div className="field_row_inner">
                                            <label>BRAND</label>
                                            <label>{item.brand}</label>
                                        </div>
                                        <div className="field_row_inner">
                                            <label>MODEL</label>
                                            <label>{item.model}</label>
                                        </div>
                                        <div className="field_row_inner">
                                            <label>OTHER MODEL NAME </label>
                                            <label>{item.desc}</label>
                                        </div>
                                    </div>)
                                })}
                                 </> :
                                 props.label==='Did you purchase or rent this camera?' ?
                                 <>
                                    <div className="field_row_inner">
                                        <label>{props.cameraPurchaseOrRent}</label>
                                    </div>
                                 </> :
                                 props.label==='Did you use Anamorphic or Spherical lenses?' ?
                                 <>
                                    <div className="field_row_inner">
                                        <label>{props.cameraAnamorphicOrSpecialLense}</label>
                                    </div>
                                 </> :
                                props.label==='Which Lenses did you use to shoot your project?' ?
                                <>
                                { props.useCameraLence && props.useCameraLence?.length >0 && props.useCameraLence?.map((item)=>{
                                return(
                                <div className="d_flex d_flex_align_center">
                                    <div className="field_row_inner">
                                        <label>BRAND</label>
                                        <label>{item.brand}</label>
                                    </div>
                                    <div className="field_row_inner">
                                        <label>MODEL</label>
                                        <label>{item.model}</label>
                                    </div>
                                    <div className="field_row_inner">
                                        <label>OTHER MODEL NAME </label>
                                        <label>{item.desc}</label>
                                    </div>
                                </div>)
                                })}
                                </> :
                                 props.label==='What influenced the camera selection?' ?
                                 <>
                                    <div className="field_row_inner">
                                        <label>{props.influencedCamera}</label>
                                        <label>{props?.influencedCameraNote}</label>
                                    </div>
                                 </> :
                                 props.label==='Which software was used to edit your film?' ?
                                 <>
                                    <div className="field_row_inner">
                                        <label>{props?.softwareUsedToEdit}</label>
                                        <label>{props?.softwareUsedToEditNote}</label>
                                    </div>
                                 </> :
                                 ''

                            }
                        </div>
                    </div>
                </div>
            </div>
        
    )
}
 class ProjectInternalView extends Component {
     constructor(props) {
         super(props)
         this.apiserve = new service();
         this.state = {
            projectUserId: this.props.PostAcceptanceEditListId,
            deleteFilm:false,
            publishFilm:false,
            disableFilm:false,
            origins:[
                {
                    id:"Asian",
                    label:"Asian",
                    value:"Asian",
                    ischecked:true
                },
                {
                    id:"African-American or African Descent",
                    label:"African-American or African Descent",
                    value:"African-American or African Descent"
                },
                {
                    id:"Caucasian/White",
                    label:"Caucasian/White",
                    value:"Caucasian/White"
                },
                {
                    id:"Latinx",
                    label:"Latinx",
                    value:"Latinx",
                    ischecked:true
                },
                {
                    id:"Middle Eastern",
                    label:"Middle Eastern",
                    value:"Middle Eastern"
                },
                {
                    id:"Native American, First Nations or Indigenous",
                    label:"Native American, First Nations or Indigenous",
                    value:"Native American, First Nations or Indigenous"
                },
                {
                    id:"Pacific Islander",
                    label:"Pacific Islander",
                    value:"Pacific Islander",
                    ischecked:true
                }, 
                {
                    id:"Bi-racial or Multi-Racial",
                    label:"Bi-racial or Multi-Racial",
                    value:"Bi-racial or Multi-Racial"
                },
                {
                    id:"Other",
                    label:"Other",
                    value:"Other"
                },
                {
                    id:"Decline to State",
                    label:"Decline to State",
                    value:"Decline to State"
                },
            ],
            adobeProductUse: [
                { id: "1", name: "none", label: "None", value: false },
                { id: "2", name: "premierePro", label: "Premiere Pro", value: false },
                { id: "3", name: "productionsInPremierePro", label: "Productions in Premiere Pro", value: false },
                { id: "4", name: "speechToTextInPremierePro", label: "Speech to Text in Premiere Pro", value: false },
                { id: "5", name: "adobeFirefly", label: "Adobe Firefly", value: false },
                { id: "7", name: "afterEffects", label: "After Effects", value: false },
                { id: "8", name: "frameIo", label: "Frame.io", value: false },
                { id: "9", name: "cameraToCloud", label: "Camera to Cloud", value: false },
                { id: "10", name: "audition", label: "Audition", value: false },
                { id: "11", name: "photoshop", label: "Photoshop", value: false },
                { id: "12", name: "illustrator", label: "Illustrator", value: false },
                { id: "13", name: "adobeMediaEncoder", label: "Adobe Media Encoder", value: false },
                { id: "14", name: "substance3D", label: "Substance 3D", value: false },
                { id: "15", name: "other", label: "Other", value: false },
            ],
            premiereFeature:[
                { id:"1", name: "textBasedEditing", label: "Text-Based Editing", value:false },
                { id:"2", name: "productionsInPremierePro", label: "Productions in Premiere Pro", value:false },
                { id:"3", name: "mediaIntelligenceSearchPanel", label: "Media Intelligence and Search panel", value:false },
                { id:"4", name: "generativeExtend", label: "Generative Extend", value:false },
                { id:"5", name: "enhanceSpeech", label: "Enhance Speech", value:false },
                { id:"6", name: "captionTranslation", label: "Caption Translation", value:false },
                { id:"7", name: "colorManagement", label: "Color Management", value:false },
            ],
            aiTools: [
                { id:"1", name: "no_ai_used", label: "No, we did not use AI at any stage", value:false },
                { id:"2", name: "ideation_concept", label: "Ideation or concept development (e.g., brainstorming, pitching)", value:false },
                { id:"3", name: "pre_production", label: "Pre-production (e.g., storyboarding or previsualization)", value:false },
                { id:"4", name: "production", label: "Production (e.g., virtual production environments, camera automation)", value:false },
                { id:"5", name: "post_production", label: "Post-production (e.g., assembly, creating temporary placeholders)", value:false },
                { id:"6", name: "visual_effects_animation", label: "Visual effects or animation", value:false },
                { id:"7", name: "sound_design_music", label: "Sound design or music (e.g., generated sound effects, cleanup)", value:false },
                { id:"8", name: "marketing_promotional", label: "Marketing or promotional materials", value:false },
                { id:"9", name: "other", label: "Other", value:false }
            ],
            fireflyModules: [
                { id: "1", name: "fireflyBoards", label: "Firefly Boards", value: false },
                { id: "2", name: "imageVideoGeneration", label: "Image and video generation in Firefly", value: false },
                { id: "3", name: "audioGeneration", label: "Audio generation in Firefly", value: false },
                { id: "4", name: "fireflyAiAssistant", label: "Firefly AI Assistant", value: false },
            ],
            stockFootage: [
                { id: "ado", name: "adobeStock", label: "Adobe Stock", value: false },
                { id: "shi", name: "shitterstock", label: "Shutterstock", value: false },
                { id: "pon", name: "pond5", label: "Pond5", value: false },
                { id: "get", name: "getty", label: "Getty", value: false },
                { id: "dis", name: "dissolve", label: "Dissolve", value: false },
                // { id: "no", name: "noUseAnyStock", label: "I did not use any stock footage.", value: false },
                { id: "opth", name: "other", label: "Other", value: false },
            ],
            realTimes3DTools :[
                { id:"notUseRealTimes3D", name: "notUseRealTimes3D", label: "I did not use a 3D real-time engine", value:false },
                { id:"Unity", name: "Unity", label: "Unity", value: false},
                { id:"Unreal", name: "Unreal", label: "Unreal", value: false},
                { id:"AdobeAero", name: "AdobeAero", label: "Adobe Aero", value: false },
                { id:"InHouse", name: "InHouse", label: "In-House/Proprietary", value: false},
                // { id:"6", name: "noUseAnyStock", label: "I did not use any stock footage", value: false },
                { id:"other",name: "other", label: "Other", value: false },
            ],
            useOtherTechnologyHardware:[
                { id: "storageDevices",name: "storageDevices", label: "Storage Devices/Hard Drives", value: false },
                { id: "desktopLaptop", name: "desktopLaptop", label: "Laptop/Desktop Computer", value: false },
                { id: "audioSoftware", name: "audioSoftware", label: "Audio Software/Hardware(pre/post)", value: false },
                { id: "soundMixingSoftware",name: "soundMixingSoftware", label: "Sound Mixing Software", value: false },
                { id: "graphicsSoftware", name: "graphicsSoftware", label: "Graphics Software", value: false },
                { id: "mobilePhoneTechnology",name: "mobilePhoneTechnology", label: "Mobile Phone Technology", value: false },
                { id: "gameEngine", name: "gameEngine", label: "Game Engine", value: false },
                { id: "vrArHeadset",name: "vrArHeadset", label: "VR/AR Headset", value: false },
                { id: "None",name: "None", label: "None", value: false },
            ],
         }
     }
     
     componentDidMount(){
        this.apiserve.sendevent("paf|project|getDetail", {});
        if(this.state.projectUserId) this.apiserve.sendevent("paf|project|getProjectInfo", { id:this.state.projectUserId }); 
        this.getAllDetails();
    };
    editProjectInfo = () => {
        // this.props.PostAcceptanceEditList(id)
        this.props.history.push(`/paf-project/${this.state.projectUserId}/Edit`)
    }
    deleteFilm = () => {
        this.setState({
          deleteFilm:true
        })  
      }
    getAllDetails(){
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "paf|project|getProjectInfo":
                    if(!response.error){
                        var ContactInfo = JSON.parse(JSON.stringify(response.data));
                        this.setState({
                            userdata: ContactInfo,
                            userInfo: {
                                mediaId: ContactInfo.mediaId ? ContactInfo.mediaId : '',
                                fileMakerId: ContactInfo.fileMakerId ? ContactInfo.fileMakerId : '',
                                title:ContactInfo.title,
                                pafType: ContactInfo.pafType,
                                article:ContactInfo.article,
                                category:ContactInfo.category,
                                filmProjectType: ContactInfo.filmProjectType,
                                englishPhoneticProdununciation: ContactInfo.englishPhoneticProdununciation,
                                studentScreening: ContactInfo.studentScreening,
                                freeCommunityScreening: ContactInfo.freeCommunityScreening,
                                historyOfFilm: ContactInfo.historyOfFilm,
                                adobeProductUse: ContactInfo.adobeProductUse,
                                aiTools: ContactInfo.aiTools || this.state.aiTools,
                                fireflyModules: ContactInfo.fireflyModules,
                                premiereFeature: ContactInfo.premiereFeature || this.state.premiereFeature,
                                stockFootage: ContactInfo.stockFootage,
                                cameras: ContactInfo.cameras,
                                cameraPurchaseOrRent: ContactInfo.cameraPurchaseOrRent,
                                cameraAnamorphicOrSpecialLense: ContactInfo.cameraAnamorphicOrSpecialLense,
                                useCameraLence: ContactInfo.useCameraLence,
                                influencedCamera: ContactInfo.influencedCamera,
                                influencedCameraNote: ContactInfo.influencedCameraNote,
                                softwareUsedToEdit: ContactInfo.softwareUsedToEdit,
                                softwareUsedToEditNote: ContactInfo.softwareUsedToEditNote,
                                useAdobeProducts: ContactInfo.useAdobeProducts,
                                useHardware: ContactInfo.useHardware,
                                useOtherTechnologyHardware: ContactInfo.useOtherTechnologyHardware,
                                realTimes3DTools: ContactInfo.realTimes3DTools,
                                useStockFootage: ContactInfo.useStockFootage,
                                fundingPlatform: ContactInfo.fundingPlatform,
                                sharingDistribution: ContactInfo.sharingDistribution,
                                hybridDistribution: ContactInfo.hybridDistribution,
                                useDropbox: ContactInfo.useDropbox,
                                brieflyExplain: ContactInfo.brieflyExplain,
                                projectId : ContactInfo._id,
                                status:ContactInfo.status
                            }
                        })
                    }else{
                        this.setState({ errorPopup:true, errorMsg: response.data.error ? response.data.error : response.data })
                    }
                    break;

                case "paf|project|getDetail":
                    if(!response.error) {
                        this.setState({ filmCategoryData:response.data.filmCategoryData,AllDropData: response.data }) }
                    else this.apiserve.error(response.data.error)
                    break;

                // case "paf|project|updateSecondPage":
                //     this.setState({loading: false})
                //     if(!response.error)
                //     {
                //         this.apiserve.success('Updated successfully.!')
                //         this.apiserve.sendevent("paf|project|getProjectInfo", { id:this.state.projectUserId });
                //     }
                //     else this.apiserve.error(response.data.error)
                //     break;

                // case "paf|project|updateThirdPage":
                //     this.setState({loading: false})
                //     if(!response.error)
                //     {
                //         this.apiserve.success('Updated successfully.!')
                //         this.apiserve.sendevent("paf|project|getProjectInfo", { id:this.state.projectUserId });
                //     }
                //     else this.apiserve.error(response.data.error)
                //     break;
                    case "paf|project|remove":
                        if(!response.error) {
                            this.props.history.push('/paf-projectlist')}
                        else this.apiserve.error(response.data.error)
                        break;
                    case "paf|project|updateStatus":
                        if(!response.error){
                            this.props.history.push('/paf-projectlist')
                        }
                        else{
                            this.setState({
                            errorPopup:true,
                            errorMsg: response.data.error ? response.data.error : response.data        
                        })
                        }
                        break;
                default:
                break;
            }
        });
    };

    deleteFilm = () => {
        this.setState({
          deleteFilm:true
        })  
      }
    
      deleteFilmPopupYes = () => {
        this.apiserve.sendevent("paf|project|remove", {
            projectId:this.state.userInfo.projectId
        });
      }
    
      publishFilm = () => {
        this.setState({
          publishFilm:true
        })  
      }
    
      publishFilmPopupYes = () => {
        this.apiserve.sendevent("paf|project|updateStatus", {
            projectId:this.state.userInfo.projectId,
            status: 1
        });
      }
    
      disableFilm = () => {
        this.setState({
          disableFilm:true
        })  
      }
    
      disableFilmPopupYes = () => {
        this.apiserve.sendevent("paf|project|updateStatus", {
            projectId:this.state.userInfo.projectId,
            status: 2
        });
      }
      errorMsgPopup = () => {
        this.setState({
            errorPopup:false
        })  
      }
    closeAdminUser = () => {
        this.setState({
          deleteFilm:false,
          publishFilm:false,
          disableFilm:false
        })
    }
    editProjectInfo = () => {
        // this.props.PostAcceptanceEditList(id)
        this.props.history.push(`/paf-project/${this.state.projectUserId}/Edit`)
    }
    deleteFilm = () => {
        this.setState({
          deleteFilm:true
        })  
    }

    deleteFilmPopupYes = () => {
        this.apiserve.sendevent("paf|project|remove", {
            projectId:this.state.userInfo.projectId
        });
    }

    publishFilm = () => {
        this.setState({
            publishFilm:true
        })  
    }

    publishFilmPopupYes = () => {
        this.apiserve.sendevent("paf|project|updateStatus", {
            projectId:this.state.userInfo.projectId,
            status: 1
        });
    }

    disableFilm = () => {
        this.setState({
            disableFilm:true
        })  
    }

    disableFilmPopupYes = () => {
        this.apiserve.sendevent("paf|project|updateStatus", {
            projectId:this.state.userInfo.projectId,
            status: 2
        });
    }
    getCategoryName = (id) => {
        return this.state.filmCategoryData && this.state.filmCategoryData.filter(_ => _._id === id).length > 0 && this.state.filmCategoryData.filter(_ => _._id === id)[0]?.name
    }

    render() {
        const { userInfo } = this.state;
        return (
            <>
            <div className="ps_contact_form ">
                <div className="d_flex d_flex_align_baseline project_section">
                    <div className="tab_col create_left_col"> </div>
                    <div className="tab_col create_feature_col">
                        <div className="fpg_edits_links mt_0 d_flex d_flex_align_center">
                            <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={()=>this.editProjectInfo()} >
                                <FpgeeditIcon /> EDIT
                            </Link>
                            {/* <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={this.editTalkAndEvent} >
                                <FpgDisableIcon /> DISABLE
                            </Link> */}
                            {/* <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.publishFilm()} >
                                <FpgpublishIcon /> PUBLISH
                            </Link> */}
                            {this.state.userInfo?.status === 1?
                            <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={()=>this.disableFilm()}>
                            <FpgDisableIcon /> DISABLE
                            </Link>
                            :              
                            <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={()=>this.publishFilm()}>
                                <FpgpublishIcon /> PUBLISH
                            </Link>
                            }
                            <Link className="d_flex d_flex_align_center d_flex_justify_center" onClick={() => this.deleteFilm()} >
                                <FpgDeleteIcon />
                                DELETE
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="text_center mb_25">
                    <h2>Internal Info</h2>
                </div>
                <div className="project_section">
                    <div className="data_list">
                        <ul className="mb_15">
                            <li className="d_flex">
                                <label>Media ID:</label>
                                <span>{this.state.userInfo?.mediaId}</span>
                            </li>
                            <li className="d_flex">
                                <label>Filemaker ID:</label>
                                <span>{this.state.userInfo?.fileMakerId}</span>
                            </li>
                        </ul>
                    </div> 
                    <div className="paf_screening_info border_btm_1 pb_20">
                        <div className="data_list">
                            <ul className="mb_15">
                                <li className="d_flex">
                                    <label>PAF Type</label>
                                    <span>{this.state.userInfo?.pafType}</span>
                                </li>
                                <li className="d_flex">
                                    <label>Film/Project</label>
                                    <span>{this.state.userInfo?.filmProjectType}</span>
                                </li>
                                <li className="d_flex">
                                    <label>Category</label>
                                    <span>{this.getCategoryName(this.state.userInfo?.category)}</span>
                                </li>
                                <li className="d_flex">
                                    <label>Article</label>
                                    <span>{this.state.userInfo?.article}</span>
                                </li>
                                <li className="d_flex">
                                    <label>Title</label>
                                    <span>{this.state.userInfo?.title}</span>
                                </li>
                                <li className="d_flex">
                                    <label>English Phonentic Pronunciation</label>
                                    <span>{this.state.userInfo?.englishPhoneticProdununciation}</span>
                                </li>
                            </ul>
                        </div> 
                    </div>  
                    {this.state.userInfo?.pafType !== PAF_TYPES.NEW_FRONTIER && <div className="pt_25 ps_contact paf_screening_info">
                        <h2 className="mb_15">Colorado Student and Community Audiences</h2>
                        <h4 className='mb_10'>Community Engagement Program</h4>
                        <p className='top_heading'>Interact with engaged local audiences including communities who may identify with your subject matter or young film students who are excited to experience independent cinema.</p>
                        <div className="data_list large_que">
                            <ul className="mb_0 pb_25 border_btm_1">
                                <li>
                                    <h3 className="mb_10 ps_contactsubtitle">Free Community Screenings</h3>
                                    <h3 className="mb_10 ps_contactsubtitle">Community screenings help make independent film more accessible, inclusive, and equitable, bringing free Festival films to local audiences. The director or another team member must participate in a Q&A for any scheduled community screenings.</h3>
                                    <div className="d_flex">
                                        <label> Are there any specific target audiences that may especially connect with your film/project? For example, particular cultural communities, language speakers, age groups, etc? If you are connected with specific organizations or community groups, especially those with a Colorado presence, please include these as well. Put N/A if not applicable. </label>
                                        {/* <span>{this.state.userInfo?.freeCommunityScreening.flag}</span> */}
                                    </div>
                                    <div className="paf_view_desc">
                                        <p>{this.state.userInfo?.freeCommunityScreening.note}</p>
                                    </div>
                                </li>
                                <li>
                                    <h3 className="mb_10 ps_contactsubtitle">University of Colorado Boulder Student Screenings</h3>
                                    <h3 className="mb_10 ps_contactsubtitle">Screenings held for University of Colorado Boulder students provide a chance for these students to experience a new perspective, gain direct exposure to the art of film, and interact with the creative team behind the story. If your film is selected, the director or another team member must participate in a Q&A for any scheduled student screenings.</h3>
                                    <div className="d_flex">
                                        <h3 className="mb_10 ps_contactsubtitle">Sensitive Content Consideration</h3>
                                        <label>Does your film contain content that might be considered sensitive? Please elaborate on the type of content your film has, e.g. strong language, substance abuse, violence (including guns), suicide, sex scenes, and/or nudity.</label>
                                        {/* <span>{this.state.userInfo?.studentScreening.flag}</span> */}
                                    </div>
                                    <div className="paf_view_desc">
                                        <p>{this.state.userInfo?.studentScreening.note} </p>
                                    </div>
                                </li>
                            </ul>
                          
                        </div>
                    </div>  }
                    <div className="pt_25 ps_contact paf_screening_info">
                        <h2 className="mb_15">History of Film/Project</h2>
                        <div className="data_list large_que">
                            <ul className="mb_0 pb_25 border_btm_1">
                                <li>
                                    <div className="d_flex">
                                        <label>Has your film/project screened at other festivals? Please name the festival, and if applicable, the name of any award(s) won.</label>
                                        <span>{this.state.userInfo?.historyOfFilm?.awardWinFlag}</span>
                                    </div>
                                    <div className="paf_view_desc">
                                        <p>{this.state.userInfo?.historyOfFilm?.awardWinNote}</p>
                                    </div>
                                </li>
                                <li>
                                    {/* <h3 className="mb_10 ps_contactsubtitle">Free Utah Community Screenings and Tickets</h3> */}
                                    <div className="d_flex">
                                        <label> Does your film have U.S. or international distribution? If so, please list companies and territories. Was it financed by any of these distributors, or was it acquired upon completion?</label>
                                        <span>{this.state.userInfo?.historyOfFilm?.acquiredForUSFlag}</span>
                                    </div>
                                    <div className="paf_view_desc">
                                        <p>{this.state.userInfo?.historyOfFilm?.acquiredForUSNote}</p>
                                    </div>
                                </li>
                                <li>
                                    {/* <h3 className="mb_10 ps_contactsubtitle">Free Utah Community Screenings and Tickets</h3> */}
                                    <div className="d_flex">
                                        <label> Was your film/project or its artist(s) supported by a Sundance Institute lab, grant, or other program prior to its selection for the Festival? If yes, please explain.</label>
                                        <span>{this.state.userInfo?.historyOfFilm?.instituteLabGrantFlag}</span>
                                    </div>
                                    <div className="paf_view_desc">
                                        <p>{this.state.userInfo?.historyOfFilm?.instituteLabGrantNote}</p>
                                    </div>
                                </li>
                                <li>
                                    {/* <h3 className="mb_10 ps_contactsubtitle">Free Utah Community Screenings and Tickets</h3> */}
                                    <div className="d_flex">
                                        <label> {`Was your film/project made in Colorado? Does it have any Colorado affiliated filmmakers or cast?`}</label>
                                        <span>{this.state.userInfo?.historyOfFilm?.isUtahFlag}</span>
                                    </div>
                                    <div className="paf_view_desc">
                                        <p>{this.state.userInfo?.historyOfFilm?.isUtahNote}</p>
                                    </div>
                                </li>
                            </ul>
                          
                        </div>
                    </div>  
                    <div className="paf_screening_question paf_que_view pt_20 pb_20">
                        <h2 className="mb_25 pb_15">Production Information</h2> 
                        {/* {this.getProductQuestion('Please enter information on up to 3 cameras (up to 3):')} */}
                        <ProductQuestion label="What camera did you use to shoot your project(make/model)?" label2='(Can enter up to 2)' cameras={this.state.userInfo?.cameras}/>
                        <ProductQuestion label="Did you purchase or rent this camera?" cameraPurchaseOrRent={this.state.userInfo?.cameraPurchaseOrRent}/>
                        <ProductQuestion label="Did you use Anamorphic or Spherical lenses?" cameraAnamorphicOrSpecialLense={this.state.userInfo?.cameraAnamorphicOrSpecialLense}/>
                        <ProductQuestion label="Which Lenses did you use to shoot your project?" label2="(Can enter up to 2)" useCameraLence={this.state.userInfo?.useCameraLence}/>
                        <ProductQuestion label="What influenced the camera selection?" influencedCamera={this.state.userInfo?.influencedCamera} influencedCameraNote={this.state.userInfo?.influencedCameraNote} />
                        <ProductQuestion label="Which software was used to edit your film?" softwareUsedToEdit={this.state.userInfo?.softwareUsedToEdit} softwareUsedToEditNote={this.state.userInfo?.softwareUsedToEditNote} />
                        <div className="field_row horizontal_field">
                            {/* <label>Text Label</label> */}
                        </div>
                        <SingleDropDown label="Did you use Adobe Creative Cloud software for any of the pre-production, production, post-production or marketing of your film?" useAdobeProducts={this.state.userInfo?.useAdobeProducts}/>
                        <div>
                            <div className="field_row">
                                    <label>If any Adobe solutions were used on your film, which ones?</label> 
                            </div>
                            <div className="d_flex ps_check_column">
                                {
                                    this.state.adobeProductUse.length > 0 && this.state.adobeProductUse.map((product,index) => {
                                        return(
                                            <CheckBox name={`product_${index}`} checked={userInfo && userInfo.adobeProductUse[product.name] ? true : false}  disable={true}  label={product.label} type="checkbox" id={product.id} />
                                        )
                                    })
                                }
                                <div className="field_row horizontal_field">
                                    <label>Other Label :  <span style={{display:'inline-block', width:'200px', borderBottom:'1px solid'}}>{userInfo?.adobeProductUse?.otherDesc}</span></label>
                                </div>
                            </div> 
                        </div>
                        <div>
                            <div className="field_row">
                                    <label>If you used Firefly, did you use any of the following modules?</label>
                            </div>
                            <div className="d_flex ps_check_column">
                                {
                                    this.state.fireflyModules.length > 0 && this.state.fireflyModules.map((module, index) => {
                                        return (
                                            <CheckBox name={`firefly_${index}`} checked={userInfo && userInfo?.fireflyModules?.[module.name] ? true : false} disable={true} label={module.label} type="checkbox" id={'f'+module.id} />
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <div>
                            <div className="field_row">
                                    <label>If you used Premiere, did you use any of the following features on your film?</label>
                            </div>
                            <div className="d_flex ps_check_column">
                                {
                                    this.state.premiereFeature.length > 0 && this.state.premiereFeature.map((product,index) => {
                                        return(
                                            <CheckBox name={`premiere_${index}`} checked={userInfo && userInfo?.premiereFeature[product.name] ? true : false}  disable={true}  label={product.label} type="checkbox" id={product.id} />
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <SingleDropDown label="Did you use any stock footage in your film?" useStockFootage={this.state.userInfo?.useStockFootage}/>
                        <div>
                            <div className="field_row">
                                    <label>If yes, which of the following sources did you use for your stock footage: Check all that apply.</label> 
                            </div>
                            <div className="d_flex ps_check_column">
                                {
                                    this.state.stockFootage.length > 0 && this.state.stockFootage.map((footage,index) => {
                                        return(
                                            <CheckBox name={`footage_${index}`} checked={userInfo && userInfo.stockFootage[footage.name] ? true : false} disable={true}  label={footage.label} type="checkbox" id={footage.id}/>
                                        )
                                    })
                                }
                                <div className="field_row horizontal_field">
                                    <label>Other Label : <span style={{display:'inline-block', width:'200px', borderBottom:'1px solid'}}>{userInfo?.stockFootage?.otherDesc}</span></label>
                                </div>
                            </div> 
                        </div>
                        <SingleDropDown label="What primary computer hardware did you use to complete your film?" useHardware={this.state.userInfo?.useHardware}/>
                        {/* <SingleDropDown label="Did you use 3D real-time tools/engines in the making of this experience?" realTimes3DTools={this.state.userInfo?.realTimes3DTools}/> */}
                            <div>
                                <div className="field_row">
                                    <label>Did you use 3D real-time tools/engines in the making of this experience?Check all that apply.</label>
                                </div>
                                <div className="d_flex ps_check_column">
                                    {

                                        this.state.realTimes3DTools.length > 0 && this.state.realTimes3DTools.map((tool, index) => {
                                            return (
                                                <CheckBox name={`realTimes3DTools_${index}`} checked={userInfo && userInfo.realTimes3DTools[tool.name] ? true : false} disable={true} label={tool.label} type="checkbox" id={tool.id} />
                                            )
                                        })
                                    }
                                    <div className="field_row horizontal_field">
                                        <label>Other Label :  <span style={{display:'inline-block', width:'200px', borderBottom:'1px solid'}}>{userInfo?.realTimes3DTools?.otherDesc}</span></label>
                                    </div>
                                </div>
                            </div>
                        
                        {/* <SingleDropDown label="Which creative funding platform did you use to produce your film?" fundingPlatform={this.state.userInfo?.fundingPlatform}/>
                        <SingleDropDown label="Are you open to sharing distribution data on your Project?" sharingDistribution={this.state.userInfo?.sharingDistribution}/>
                        <SingleDropDown label="Do you have interest in hybrid distribution?" hybridDistribution={this.state.userInfo?.hybridDistribution}/> */}
                        <SingleDropDown label="Did you use Dropbox (or Dropbox Replay, Sign, or DocSend) during the planning, production, or distribution of your film/project?" useDropbox={this.state.userInfo?.useDropbox}/>
                        <div className="paf_view_desc">
                            <p>{this.state.userInfo?.brieflyExplain}</p>
                        </div>
                        <div className='mt_15'>
                            <div className="field_row">
                                    <label>Did you use any artificial intelligence (AI) tools or workflows in the creation of your film?</label>
                            </div>
                            <div className="d_flex" style={{maxWidth:'750px'}}>
                                {
                                    this.state.aiTools.length > 0 && this.state.aiTools.map((product, index) => {
                                        const hasSubField = ['ideation_concept', 'pre_production', 'production', 'post_production', 'visual_effects_animation', 'sound_design_music', 'marketing_promotional'].includes(product.name)
                                        const isChecked = userInfo && userInfo?.aiTools[product.name] ? true : false
                                        return (
                                            <React.Fragment key={product.id}>
                                                <div className='' style={{width:'50%'}}>
                                                    <CheckBox name={`aitool_${index}`} checked={isChecked} disable={true} label={product.label} type="checkbox" id={product.id} />
                                                    {hasSubField && isChecked && (
                                                        <div className="field_row horizontal_field" style={{paddingLeft:'20px'}}>
                                                            <label><span style={{display:'inline-block', minWidth:'200px', borderBottom:'1px solid'}}>{userInfo?.aiTools?.[`${product.name}_tool`]}</span></label>
                                                        </div>
                                                    )}
                                                    {userInfo?.aiTools?.other && product.name === 'other' && (
                                                        <div className="field_row horizontal_field" style={{paddingLeft:'20px'}}>
                                                            <label><span style={{display:'inline-block', minWidth:'200px', borderBottom:'1px solid'}}>{userInfo?.aiTools?.otherDesc}</span></label>
                                                        </div>
                                                    )}
                                                </div>
                                            </React.Fragment>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {this.state.errorPopup ? 
                  <ErrorPopUp
                  errorMsg={this.state.errorMsg}
                  errorMsgPopup={this.errorMsgPopup}
                  />    
              : ''
        }
      {this.state.deleteFilm ? 
          <PopUpCustomAll 
            HeaderName = 'Delete?'
            insideDetails = 'You are about to delete an item and this action is permanent'
            insideData =  'Do you want to proceed?'
            popupState = {this.closeAdminUser}
            yesPopUp = {this.deleteFilmPopupYes}
          />
        :''}

      {this.state.publishFilm ? 
          <PopUpCustomAll 
            HeaderName = 'Publish Changes'
            insideDetails = 'Saving the current changes will publish it to the production site'
            insideData =  'Do you want to proceed?'
            popupState = {this.closeAdminUser}
            yesPopUp = {this.publishFilmPopupYes}
          />
        :''}

      {this.state.disableFilm ? 
          <PopUpCustomAll 
            HeaderName = 'Disable?'
            insideDetails = 'You are about to disable an item, which will temporarily make it unavailable on the production site'
            insideData =  'Do you want to proceed?'
            popupState = {this.closeAdminUser}
            yesPopUp = {this.disableFilmPopupYes}
          />
        :''}
         {this.state.loaderFlag ? (
                    <Loader />
          ) : (
                  ""
            )}
        </>   
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ProjectInternalView)
// export default ProjectInternalView